import produce from "immer";
import { AppThunkAction } from "..";
import { kinesenseApiSlice } from "../api/kinesense";

export interface GeneralState {
    activeProjectId: string | undefined;
}

export interface SetActiveProjectAction {
    type: "general/setActiveProject";
    payload: string;
}

export type KnownAction = SetActiveProjectAction;

export const actionCreators = {
    setActiveProject:
        (projectId: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const previousProjectId = getState().general?.activeProjectId;
            dispatch({ type: "general/setActiveProject", payload: projectId });

            if (projectId.length === 0 || previousProjectId === projectId) {
                return;
            }

            const state = getState();
            if (!state.user?.isLoggedIn || state.user.session === undefined) {
                return;
            }

            dispatch(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                kinesenseApiSlice.endpoints.updateCurrentUserConfig.initiate({ lastProjectId: projectId }) as any,
            );
        },
};

const initialState: GeneralState = {
    activeProjectId: undefined,
};

export const reducer = (state: GeneralState | undefined, action: KnownAction): GeneralState => {
    if (state === undefined) {
        return initialState;
    }

    return produce(state, (draft) => {
        switch (action.type) {
            case "general/setActiveProject":
                draft.activeProjectId = action.payload;
                break;
        }
    });
};
